import React, { useState, Children, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MaximizeIcon } from 'lucide-react';
import ImageModal from './ImageModal';
interface ImageGalleryProps {
  images: {
    url: string;
    alt: string;
  }[];
}
const ImageGallery: React.FC<ImageGalleryProps> = ({
  images
}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  return <div className="mt-12" data-id="element-101">
      <motion.div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" initial="initial" animate="animate" variants={{
      initial: {},
      animate: {
        transition: {
          staggerChildren: 0.05
        }
      }
    }} data-id="element-102">
        {images.map((image, index) => <motion.div key={index} variants={{
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        }
      }} className="aspect-[4/3] relative group cursor-pointer overflow-hidden rounded-2xl" onClick={() => setSelectedImage(image.url)} onMouseEnter={() => setHoveredIndex(index)} onMouseLeave={() => setHoveredIndex(null)} data-id="element-103">
            <motion.div className="absolute inset-0 bg-black/10 group-hover:bg-black/30 transition-colors duration-300 z-10 flex items-center justify-center" initial={{
          opacity: 0
        }} whileHover={{
          opacity: 1
        }} data-id="element-104">
              <div className="bg-white/80 backdrop-blur-sm rounded-full p-2 transform transition-transform duration-300 hover:scale-110" data-id="element-105">
                <MaximizeIcon className="w-5 h-5 text-gray-800" data-id="element-106" />
              </div>
            </motion.div>
            <motion.img src={`${image.url}?w=600&q=75`} alt={image.alt} className="w-full h-full object-cover" loading="lazy" animate={{
          scale: hoveredIndex === index ? 1.05 : 1
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} data-id="element-107" />
          </motion.div>)}
      </motion.div>
      <ImageModal isOpen={!!selectedImage} onClose={() => setSelectedImage(null)} imageUrl={selectedImage || ''} alt="Gallery image" data-id="element-108" />
    </div>;
};
export default ImageGallery;